<template>
	<div
		class="carousel-step">
		<div class="carousel-step__left">
			<div class="carousel-step__text">
				<slot name="text"/>
			</div>
		</div>
		<div
			:ref="setup._preview"
			class="carousel-step__right">
			<slot name="img"/>
		</div>
	</div>
</template>

<script setup lang="ts">
import CarouselContentSetupService from '@/setup/carousel/CarouselContentSetupService';
const setup = new CarouselContentSetupService();
</script>

<style lang="less">
@import '@/styles/mixins';
@import '@/styles/variables';

.carousel-step {
  display: flex;
  position: relative;
  min-width: 100%;
  min-height: 16.25rem;
  overflow: hidden;

  &__left, &__right {
    flex: 1;
  }

  &__left {
    padding: 1.25rem;

		@media @tablet {
			max-width: 50%;
		}
  }

  &__right {
    height: auto;
    width: 50%;
		display: none;

		@media @tablet {
			display: block;
		}
  }
}
</style>
